import React, { useEffect, useState } from 'react';
import '../incentiveSummary/incentiveSummary.css';
import { ConfirmationPopUp } from '../../../components/popup/confirmationPopUp';
import { Button } from '@mui/material';
import { DataGrid } from '@mui/x-data-grid';
import { useLocation, useNavigate } from 'react-router-dom';
import axios from 'axios';
import { useSelector } from 'react-redux';
import { resetIncentiveState, updateIncentiveData } from '../../../stateManagement/actions/incentiveActions';
import DefaultHeading from '../../../components/heading/DefaultHeading';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { ChannelkartNetworkPost, ChannelkartNetworkPut } from '../../../services/networkService';
import { EnvironmentRegistry } from '../../../services/registry/environmentRegistry';
import { openPopup } from '../../../stateManagement/actions/popupActions';
import RenderSvg from '../../../components/renderSvg/RenderSvg';
import { SubmitPopUp } from './submitPopUp';
import { LoadingOverlay } from '@mantine/core';


export const CreateIncentivePreview = () => {
    const [openDialog, setOpenDialog] = useState(false);
    const [msg , setMsg] = useState("");
    const location = useLocation();
    const [loading , setLoading] = useState(false)
    const bodyObject: any = location.state;
    const [data, setData] = useState<any[]>([]);
    const navigate = useNavigate();
    const storeData: Record<string, any> = useSelector((state: any) => state?.manageIncentive?.data);
    const valueMappingFromApi: any = {
        "MONTH": "MONTHLY",
        "PERIOD": "PERIOD",
        "WEEK": "WEEKLY",
        "SALESTARGET": "Sales Target",
        "CROSSSELL": "Cross Sell",
        "UPSELL": "Recover",
        "FOCUS": "Focus Product",
        "CROSSSELLPARENT": "Cross Sell",
        "UPSELLPARENT": "Recover",
        "FOCUSPARENT": "Focus Product"
    };

    useEffect(() => {
        if (bodyObject) {
            const transformedData = [
                {
                    id: "id",
                    incentiveCalculation: bodyObject.bodyObject.action,
                    incentiveFrequency: valueMappingFromApi[bodyObject.bodyObject.duration],
                    userSelection: bodyObject.bodyObject.designations.join(", "),
                    kpiSelection: bodyObject.bodyObject.kpiWithPoints.map((kpi: any) => valueMappingFromApi[kpi.name] || kpi.name).join('\n'),
                    pointsDefined: bodyObject.bodyObject.kpiWithPoints.map((kpi: any) => kpi.point).join('\n'),
                    incentiveName: bodyObject.bodyObject.incentiveName,
                    redemptionThreshold: bodyObject.bodyObject.redemptionValue.map((threshold: any) =>
                        `${threshold.startPercentage}% - ${threshold.endPercentage}%`
                    ).join('\n'),
                    redemptionValue: bodyObject.bodyObject.redemptionValue.map((threshold: any) =>
                        threshold.value
                    ).join('\n'),
                    fromDate: bodyObject.bodyObject.startTime.split(' ').length > 1 ? bodyObject.bodyObject.startTime.split(' ')[0] : bodyObject.bodyObject.startTime,
                    toDate: bodyObject.bodyObject.endTime.split(' ').length > 1 ? bodyObject.bodyObject.endTime.split(' ')[0] : bodyObject.bodyObject.endTime,

                }
            ]
            setData(transformedData);
        }
    }, [bodyObject]);

    const postIncentiveData = async () => {
        const requestBody = bodyObject.bodyObject;
        if (localStorage.editIncentiveID) {
            requestBody["id"] = localStorage.editIncentiveID;
            try {
                let response: any = {};
                // if (EnvironmentRegistry.getEnvironment() == 'uat') {
                //     response = await ChannelkartNetworkPut('https://reward-service-uat.salescode.ai/v1/incentiveinfo', requestBody);
                // }

                // if (EnvironmentRegistry.getEnvironment() == 'demo') {
                //     response = await ChannelkartNetworkPut('https://rewardsdemo.sellina.io/v1/incentiveinfo', requestBody);
                // }
                let rewardsUrl = EnvironmentRegistry.getRewardsUrl();
                response = await ChannelkartNetworkPut(`${rewardsUrl}/v1/incentiveinfo`, requestBody);

                if (response.status === 200) {
                    setMsg(`Incentive data posted successfully`)
                    setOpenDialog(true);
                    console.log('Incentive data posted successfully:', response.data);
                } else {
                    setMsg(`${response.data.message}`)
                    setOpenDialog(true);
                    console.error('Failed to post incentive data:', response.status);
                }
            } catch (error) {
                setMsg(`Failed to post incentive data`)
                setOpenDialog(true);
                console.error('Error posting incentive data:', error);
            }
        } else {
            try {
                let response: any = {};
                // if (EnvironmentRegistry.getEnvironment() == 'uat') {
                //     response = await ChannelkartNetworkPost('https://reward-service-uat.salescode.ai/v1/incentiveinfo', requestBody);
                // }

                // if (EnvironmentRegistry.getEnvironment() == 'demo') {
                //     response = await ChannelkartNetworkPost('https://rewardsdemo.sellina.io/v1/incentiveinfo', requestBody);
                // }
                let rewardsUrl = EnvironmentRegistry.getRewardsUrl();
                response = await ChannelkartNetworkPost(`${rewardsUrl}/v1/incentiveinfo`, requestBody);

                if (response.status === 200) {
                    setMsg(`Incentive data posted successfully`)
                    setOpenDialog(true);
                    console.log('Incentive data posted successfully:', response.data);
                } else {
                    setMsg(`${response.data.message}`)
                    setOpenDialog(true);
                    console.error('Failed to post incentive data:', response.status);
                }
            } catch (error) {
                setMsg(`Failed to post incentive data`)
                setOpenDialog(true);
                console.error('Error posting incentive data:', error);
            }
        }
        
    };

    const columns = [
        {
            field: "incentiveCalculation", headerName: "Incentive Calculation", width: 140, renderHeader: () => (
                <div style={{ display: 'flex', alignItems: 'center', whiteSpace: 'pre-line', lineHeight: "18px" }}>
                    <RenderSvg name="calculator" />
                    <div style={{ marginLeft: '12px', fontWeight: 500 }}>Incentive{"\n"} Calculation</div>

                </div>
            ),sortable: false,
            disableColumnMenu: true,
        },
        {
            field: "incentiveFrequency", headerName: "Incentive Frequency", width: 140, renderHeader: () => (
                <div style={{ display: 'flex', alignItems: 'center', whiteSpace: 'pre-line', lineHeight: "18px" }}>

                    <RenderSvg name="incentive_frequency" />
                    <div style={{ marginLeft: '12px', fontWeight: 500 }}>Incentive{"\n"} Frequency</div>

                </div>
            ),sortable: false,
            disableColumnMenu: true,
        },
        {
            field: 'userSelection',
            headerName: 'User Selection',
            width: 180,
            renderCell: (params: any) => (
                <div style={{ whiteSpace: 'pre-line' }}>{params.value}</div>
            ), renderHeader: () => (
                <div style={{ display: 'flex', alignItems: 'center', whiteSpace: 'pre-line', lineHeight: "18px" }}>

                    <RenderSvg name="role_selection" />
                    <div style={{ marginLeft: '12px', fontWeight: 500 }}>Role{"\n"} Selection</div>

                </div>
            ),sortable: false,
            disableColumnMenu: true,
        },
        {
            field: 'kpiSelection',
            headerName: 'KPI Selection',
            width: 370,
            renderCell: (params: any) => (
                <div style={{ whiteSpace: 'pre-line', maxHeight: '60px', overflowY: 'auto' }}>
                    {params.value}
                </div>
            ), renderHeader: () => (
                <div style={{ display: 'flex', alignItems: 'center', whiteSpace: 'pre-line', lineHeight: "18px" }}>

                    <RenderSvg name="kpi_chosen" />
                    <div style={{ marginLeft: '12px', fontWeight: 500 }}>KPI{"\n"} Chosen</div>

                </div>
            ),sortable: false,
            disableColumnMenu: true,
        },
        {
            field: 'pointsDefined',
            headerName: 'Points Defined',
            width: 160,
            renderCell: (params: any) => (
                <div style={{ whiteSpace: 'pre-line', maxHeight: '60px', overflowY: 'auto' }}>
                    {params.value}
                </div>
            ), renderHeader: () => (
                <div style={{ display: 'flex', alignItems: 'center', whiteSpace: 'pre-line', lineHeight: "18px" }}>

                    <RenderSvg name="points_defined" />
                    <div style={{ marginLeft: '12px', fontWeight: 500 }}>Points{"\n"} Defined</div>

                </div>
            ),sortable: false,
            disableColumnMenu: true,
        },
        {
            field: 'incentiveName',
            headerName: 'Incentive Name',
            width: 180,
            renderCell: (params: any) => (
                <div
                    style={{
                        whiteSpace: 'pre-line',    // Keep multiline formatting
                        maxHeight: '60px',         // Set max height for the cell content
                        overflowY: 'auto',         // Enable vertical scrolling
                        padding: '5px',            // Optional: Add some padding for better aesthetics
                    }}
                >{params.value}</div> // Multiline for points
            ), renderHeader: () => (
                <div style={{ display: 'flex', alignItems: 'center', whiteSpace: 'pre-line', lineHeight: "18px" }}>

                    <RenderSvg name="incentive_id" />
                    <div style={{ marginLeft: '12px', fontWeight: 500 }}>Incentive{"\n"} Name</div>

                </div>
            ),sortable: false,
            disableColumnMenu: true,
        },
        {
            field: "redemptionThreshold",
            headerName: "Redemption Threshold",
            width: 180,
            renderCell: (params: any) => (
                <div style={{ whiteSpace: 'pre-line',maxHeight: '60px' , overflowY: 'auto'  }}>
                    {params.value}
                </div>
            ), renderHeader: () => (
                <div style={{ display: 'flex', alignItems: 'center', whiteSpace: 'pre-line', lineHeight: "18px" }}>

                    <RenderSvg name="redemption_threshold" />
                    <div style={{ marginLeft: '12px', fontWeight: 500 }}>Redemption{"\n"} Threshold</div>

                </div>
            ),sortable: false,
            disableColumnMenu: true,
        },
        {
            field: "redemptionValue",
            headerName: "Redemption Value",
            width: 160,
            renderCell: (params: any) => (
                <div style={{ whiteSpace: 'pre-line',maxHeight: '60px' , overflowY: 'auto' }}>
                    {params.value}
                </div>
            ), renderHeader: () => (
                <div style={{ display: 'flex', alignItems: 'center', whiteSpace: 'pre-line', lineHeight: "18px" }}>

                    <RenderSvg name="redemption_value" />
                    <div style={{ marginLeft: '12px', fontWeight: 500 }}>Redemption{"\n"} value</div>

                </div>
            ),sortable: false,
            disableColumnMenu: true,
        },
        {
            field: "fromDate",
            headerName: "From Date",
            width: 140,
            renderCell: (params: any) => (
                <div>{params.value}</div>
            ), renderHeader: () => (
                <div style={{ display: 'flex', alignItems: 'center', whiteSpace: 'pre-line', lineHeight: "18px" }}>

                    <RenderSvg name="calendar" />
                    <div style={{ marginLeft: '12px', fontWeight: 500 }}>From{"\n"} Date</div>

                </div>
            ),sortable: false,
            disableColumnMenu: true,
        },
        {
            field: "toDate",
            headerName: "To Date",
            width: 140,
            renderCell: (params: any) => (
                <div>{params.value}</div>
            ), renderHeader: () => (
                <div style={{ display: 'flex', alignItems: 'center', whiteSpace: 'pre-line', lineHeight: "18px" }}>

                    <RenderSvg name="calendar" />
                    <div style={{ marginLeft: '12px', fontWeight: 500 }}>To{"\n"} Date</div>

                </div>
            ),sortable: false,
            disableColumnMenu: true,
        }
    ];

    const redirectToSummaryPage = () => {
        delete localStorage.incentiveData;
        navigate('/dashboard/incentiveDashboard', { replace: true });
        navigate(-2);
    };

    const editIncentive = () => {
        navigate(-1);
    }
    return (
        <div className='incentive-summary-body'>
            <DefaultHeading heading='Incentive Preview' />

            <div className="incentiveDataGridContainer">
                <div style={{ marginTop: "25px", marginLeft: "20px" }}>
                    <DataGrid
                        disableColumnMenu
                        disableColumnFilter
                        disableColumnSelector
                        hideFooter
                        hideFooterSelectedRowCount
                        sx={{
                            paddingInline: '0px',  // Remove padding
                            margin: '0px',         // Remove margin

                            // Center the headers and their SVGs
                            '& .MuiDataGrid-columnHeaderTitleContainer': {
                                justifyContent: 'center',
                                alignItems: 'center',
                            },

                            // Center the content inside the cells
                            '& .MuiDataGrid-cell': {
                                display: 'flex',
                                justifyContent: 'center',
                                alignItems: 'center',
                                fontWeight: 500,
                                borderRight: '0.1px solid #E9EFF5',
                                borderBottom: '0.1px solid #E9EFF5' // Thinner grid lines
                            },

                            // Center the headers and apply thinner grid lines
                            '& .MuiDataGrid-columnHeaders': {
                                borderRight: '0.1px solid #E9EFF5', // Thinner grid lines
                            },

                            // Decrease the width of the grid lines
                            '& .MuiDataGrid-columnHeader': {
                                borderRight: '0.1px solid #E9EFF5', // Thinner grid lines
                            },
                            '& .MuiDataGrid-columnHeaderTitle': {
                                fontWeight: 'bold'
                            }
                        }}
                        autoHeight
                        rowHeight={80}
                        className='live_dashboard_table'
                        columns={columns}
                        getRowId={(data: any) => data.id}
                        rows={data}
                    />
                </div>
                <div className='incentive-next-button-wrapper'>

                    <Button
                        variant="contained"
                        sx={{
                            marginLeft: 2,
                            height: 35,
                            fontSize: '0.8rem',
                            marginTop: 2,
                            marginRight: 1
                        }}
                        onClick={editIncentive}
                    >
                        EDIT
                    </Button>
                    <Button
                        variant="contained"
                        sx={{
                            marginLeft: 2,
                            height: 35,
                            fontSize: '0.8rem',
                            marginTop: 2,
                            marginRight: 1
                        }}
                        onClick={postIncentiveData}
                    >
                        SUBMIT
                    </Button>
                    <Button
                        variant="contained"
                        sx={{
                            marginLeft: 2,
                            height: 35,
                            fontSize: '0.8rem',
                            marginTop: 2,
                            marginRight: 1
                        }}
                        onClick={redirectToSummaryPage}
                    >
                        GO TO SUMMARY
                    </Button>
                </div>
                <SubmitPopUp
                    setOpenConfirmModal={setOpenDialog}
                    message={msg}
                    openConfirmModal={openDialog}
                    successMethod={async () => {
                        delete localStorage.incentiveData;

                        navigate('/dashboard/incentiveDashboard', { replace: true });
                        navigate(-2);
                        resetIncentiveState(true);

                    }}
                />
                <LoadingOverlay
                    loaderProps={{ size: 'sm', color: 'teal', variant: 'bars' }}
                    visible={loading}
                    style={{ position: "fixed" }}
                />

            </div>
        </div>

    );
};
